import { render } from "./ModalUnsavedCaseAlert.vue?vue&type=template&id=2158dafc&scoped=true"
import script from "./ModalUnsavedCaseAlert.vue?vue&type=script&lang=js"
export * from "./ModalUnsavedCaseAlert.vue?vue&type=script&lang=js"

import "./ModalUnsavedCaseAlert.vue?vue&type=style&index=0&id=2158dafc&scoped=true&lang=scss"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2158dafc"]])

export default __exports__